import React, { useState } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { 
  faShieldAlt, 
  faArrowRight
} from '@fortawesome/free-solid-svg-icons';
import { SuccessGuaranteeModal } from '../../../components/common/CommonModals';

const SuccessGuaranteeBadge = ({ theme }) => {
  const [isModalOpen, setIsModalOpen] = useState(false);

  const styles = {
    badge: {
      display: 'inline-flex',
      alignItems: 'center',
      gap: '8px',
      padding: '12px 16px',
      background: `linear-gradient(135deg, ${theme?.primary?.blue?.[100]} 0%, ${theme?.primary?.blue?.[300]} 100%)`,
      border: `0px solid ${theme?.primary?.blue?.[500]}`,
      borderRadius: '12px',
      cursor: 'pointer',
      transition: 'all 0.2s ease',
      boxShadow: '0 2px 8px rgba(0, 0, 0, 0.1)',
      
      fontWeight: '500',
      color: theme?.text?.primary,
      marginTop: '16px',
      fontSize: '.75rem',
      fontWeight: '500'
    },
    badgeHover: {
      transform: 'translateY(-2px)',
      boxShadow: '0 4px 12px rgba(0, 0, 0, 0.15)',
    }
  };

  const handleBadgeClick = () => {
    setIsModalOpen(true);
  };

  const handleCloseModal = () => {
    setIsModalOpen(false);
  };

    return (
    <>
      <div className="inline-flex items-center px-8 py-4 font-semibold rounded-lg hover:scale-105 hover:shadow-lg transition-all duration-200"
        style={styles.badge}
        
        onClick={handleBadgeClick}
      >
        <FontAwesomeIcon 
          icon={faShieldAlt} 
          style={{ color: theme?.primary?.blue?.[500] }}
        />
        <span>LearnZapp Success Guarantee - Pass your exam or get 3 months free</span>
        <FontAwesomeIcon 
          icon={faArrowRight} 
          style={{ color: theme?.primary?.blue?.[500] }}
        />
      </div>

      <SuccessGuaranteeModal 
        isOpen={isModalOpen} 
        onClose={handleCloseModal} 
        theme={theme} 
      />
    </>
  );
};

export default SuccessGuaranteeBadge;
